// recommendation-popup.js

document.addEventListener('DOMContentLoaded', function () {

  // Helper functions to show/hide popup
  window.showRecommendationPopup = function () {
    const popup = document.getElementById('RecommendationModal');
    if (popup) {
      popup.style.display = 'flex';
      popup.classList.add('active');
    }
  };

  window.hideRecommendationPopup = function () {
    const popup = document.getElementById('RecommendationModal');
    if (popup) {
      popup.style.display = 'none';
      popup.classList.remove('active');
    }
  };

  // Close popup when clicking outside or pressing Escape
  document.addEventListener('click', function (e) {
    const popup = document.getElementById('RecommendationModal');
    if (popup && e.target === popup) hideRecommendationPopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideRecommendationPopup();
  });

  // Function to render recommended products
  async function renderRecommendedProducts(productId) {
    console.log(productId);
    const container = document.getElementById('recommendation-products');
    if (!container) return;

    // Fetch product JSON to get metafields
    try {
      const response = await fetch(`/products/${productId}.js`);
      const product = await response.json();

      // Metafield for recommendations (expects up to 2 products)
      let recommendations = [];
      if (
        product.metafields &&
        product.metafields.custom &&
        product.metafields.custom.recommendation
      ) {
        // It could be single ID or array of IDs
        if (Array.isArray(product.metafields.custom.recommendation)) {
          recommendations = product.metafields.custom.recommendation.slice(0, 2);
        } else {
          recommendations = [product.metafields.custom.recommendation];
        }
      }

      if (recommendations.length === 0) {
        container.innerHTML =
          '<p style="color:#6b7280; text-align:center; margin-top:2rem;">No recommended products for this item.</p>';
        return;
      }

      container.innerHTML = ''; // clear previous
      for (const recHandle of recommendations) {
        const recResponse = await fetch(`/products/${recHandle}.js`);
        const recProduct = await recResponse.json();
        const variantId =
          recProduct.variants && recProduct.variants.length
            ? recProduct.variants[0].id
            : null;

        if (!variantId) continue;

        const productCard = document.createElement('div');
        productCard.className = 'product-card';
        productCard.style.textAlign = 'center';
        productCard.innerHTML = `
          <div class="product-image" style="margin-bottom:1rem; border:1px solid #e5e7eb; border-radius:8px; padding:1.5rem;">
            ${
              recProduct.featured_image
                ? `<img src="${recProduct.featured_image}" alt="${recProduct.title}" style="width:100%; height:auto; border-radius:8px;">`
                : `<div style="width:100%; height:120px; background:#f9fafb; border:1px dashed #d1d5db; display:flex; align-items:center; justify-content:center; border-radius:8px; color:#6b7280;">No Image</div>`
            }
          </div>
          <div class="product-info">
            <div style="font-size:1.525rem; margin-bottom:1rem;">
              ${
                recProduct.compare_at_price > recProduct.price
                  ? `<span style="text-decoration: line-through; opacity:0.6; margin-right:0.5rem;">${Shopify.formatMoney(recProduct.compare_at_price)}</span> <span>${Shopify.formatMoney(recProduct.price)}</span>`
                  : `${Shopify.formatMoney(recProduct.price)}`
              }
            </div>
            <h3 style="font-size:1.125rem; font-weight:400; margin-bottom:0.5rem; color:#111827;">${
              recProduct.title
            }</h3>
            <div style="font-size:0.875rem; color:#6b7280; margin-bottom:1rem; line-height:1.4;">
              ${recProduct.description
                ? recProduct.description.replace(/(<([^>]+)>)/gi, '').substring(0, 100)
                : recProduct.title + ' - High quality product.'}
            </div>
            <button class="add-to-cart-btn" data-variant-id="${variantId}" style="display:inline-block; padding:0.75rem 1.5rem; background:#111827; color:white; border:none; border-radius:6px; cursor:pointer; width:100%; font-size:0.875rem; font-weight:500;">
              Add to Cart
            </button>
          </div>
        `;
        container.appendChild(productCard);
      }

      attachAddToCartEvents(); // attach AJAX cart events

    } catch (error) {
      console.error('Error fetching recommended products:', error);
    }
  }

  // Attach AJAX add-to-cart for recommended products
  function attachAddToCartEvents() {
    const buttons = document.querySelectorAll('#recommendation-products .add-to-cart-btn');
    buttons.forEach((btn) => {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const originalText = this.textContent;
        this.textContent = 'Adding...';
        this.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          const data = await res.json();

          this.textContent = 'Added!';
          this.style.background = '#10b981';
          setTimeout(() => {
            hideRecommendationPopup();
            this.textContent = originalText;
            this.style.background = '';
            this.disabled = false;
          }, 1500);
        } catch (err) {
          console.error(err);
          this.textContent = 'Error';
          setTimeout(() => {
            this.textContent = originalText;
            this.disabled = false;
          }, 2000);
        }
      });
    });
  }

  // Auto-show popup if trigger_on_cart is true
  document.addEventListener('cart:updated', function (e) {
    const currentProductHandle = e.detail?.product?.handle;
    if (!currentProductHandle) return;
    renderRecommendedProducts(currentProductHandle);
    showRecommendationPopup();
  });

  // Optional: auto-show on page load for testing/design
  if (document.documentElement.classList.contains('shopify-design-mode')) {
    setTimeout(() => showRecommendationPopup(), 2000);
  }

  // Optional: show via URL ?show_popup=true
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('show_popup') === 'true') {
    setTimeout(() => showRecommendationPopup(), 1000);
  }
});
